document.addEventListener("DOMContentLoaded", function () {
  let collection_url = "/collections/";

  // category和product切换
  $(".accessories_filter .main_filter .filter_box").click(function () {
    if ($(this).hasClass("active")) {
      return;
    } else {
      window.location.href =
        collection_url + $(this).find(".fitler_select").data("filter-type");
    }
  });

  // 判断是否是shop by category
  let is_category = false;
  if (window.location.pathname.indexOf("shop-by-category") != -1) {
    is_category = true;
  }

  // 获取url最后一个参数
  let path = window.location.pathname.split("/");
  let lastPart = path[path.length - 1];

  // 如果是shop by category
  if (is_category) {
    $(".type_content .fitler_type").toggle();
    $(".accessories_filter .main_filter .filter_box").toggleClass("active");
    // 如果最后一个参数是下拉框选项，需要获取数据，设置select的value
    if (lastPart != "shop-by-category") {
      getCategoryData(window.location.href, ".type_content .shop_by_category");
      $("#filter-select-2").val(lastPart);
    }
  } else {
    // 如果是shop by product,且最后一个参数是下拉框选项，需要获取数据，设置select的value
    if (lastPart != "shop-by-product") {
      $("#filter-select-1").val(lastPart);
      updateByProduct(lastPart);
    } else {
      $(".shop_by_product .product_list .main_accessories").css(
        "display",
        "flex"
      );
    }
  }

  // 下拉框选中触发事件
  $(".main_filter .filter_box .fitler_select").change(function () {
    let keyword = $(this).val();
    let url;
    // 修改地址栏url
    if (keyword == "All") {
      url = collection_url + $(this).data("filter-type");
    } else {
      url = collection_url + $(this).data("filter-type") + "/" + keyword;
    }
    window.history.pushState(null, null, url);
    // 判断是category还是product的下拉框updateByProduct
    if ($(this).data("filter-type") == "shop-by-product") {
      updateByProduct(keyword);
      // 如果search框不为空，需过滤
      if ($("#search-form input").val().toLowerCase().trim() != "") {
        search_by_product($("#search-form input").val().toLowerCase().trim());
      }
    } else {
      // 局部刷新获取数据
      // getCategoryData(url, '.type_content .shop_by_category');
      window.location.href = url;
    }
  });

  function updateByProduct(keyword) {
    $(".shop_by_product .product_list .main_accessories").each(function (
      index,
      item
    ) {
      if (keyword == "all") {
        $(item).css("display", "flex");
      } else {
        if ($(item).data("type") == keyword) {
          $(item).css("display", "flex");
        } else {
          $(item).css("display", "none");
        }
      }
    });
  }

  // 异步获取category的数据
  function getCategoryData(url, dom) {
    fetch(url, {
      credentials: "same-origin",
      method: "GET",
    }).then(function (response) {
      response.text().then(function (content) {
        let tempElement = document.createElement("div");
        tempElement.innerHTML = content;
        console.log(dom, content);
        document.querySelector(dom).innerHTML =
          tempElement.querySelector(dom).innerHTML;
        if ($("#search-form input").val().toLowerCase().trim() != "") {
          search_by_category(
            $("#search-form input").val().toLowerCase().trim()
          );
        }
      });
    });
  }

  // 搜索框
  $(".main_search #search-form").submit(function (e) {
    e.preventDefault();
    let keyword = $("#search-form input").val().toLowerCase().trim();
    if (is_category) {
      search_by_category(keyword);
    } else {
      search_by_product(keyword);
    }
  });

  $("#search-form input").on("focus", function () {
    $(this).siblings("svg").hide();
  });

  $("#search-form input").on("blur", function () {
    if ($(this).val() == "") {
      $(this).siblings("svg").show();
      $(this).css("padding-left", "45px");
    } else {
      $(this).css("padding-left", "15px");
    }
  });

  // category搜索，产品名匹配
  function search_by_category(keyword) {
    console.log(keyword);
    if (keyword != "") {
      $(".shop_by_category .product_box .grid__item").each(function (
        index,
        item
      ) {
        if (
          $(item)
            .find(".grid-view-item__title")
            .text()
            .toLowerCase()
            .indexOf(keyword) != -1
        ) {
          $(item).css("display", "block");
        } else {
          $(item).css("display", "none");
        }
      });
    } else {
      getCategoryData(window.location.href, ".type_content .shop_by_category");
    }
  }

  // product搜索，产品名匹配
  function search_by_product(keyword) {
    if (keyword != "") {
      $(".shop_by_product .product_list .main_accessories").each(function (
        index,
        item
      ) {
        if (
          $(item).find(".product_name").text().toLowerCase().indexOf(keyword) !=
          -1
        ) {
          if ($(item).css("display") == "none") {
            return;
          } else {
            $(item).css("display", "flex");
          }
        } else {
          $(item).css("display", "none");
        }
      });
    } else {
      updateByProduct($("#filter-select-1").val());
    }
  }
  
  // 后退刷新页面
  window.addEventListener("popstate", function (event) {
    window.location.reload();
  });
});
